import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import Footer from "@/components/Footer";
import Reveal from "@/components/Reveal";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState("All");

  useEffect(() => {
    api
      .get("/products")
      .then((r) => setProducts(r.data || []))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, []);

  const categories = ["All", ...Array.from(new Set(products.map((p) => p.category).filter(Boolean)))];
  const visible = category === "All" ? products : products.filter((p) => p.category === category);

  return (
    <div>
      <div className="mx-auto max-w-7xl px-4 pb-10 pt-32 sm:px-8 lg:px-16">
        <p className="via-label">Est. Ellan Vannin</p>
        <h1 className="font-display text-5xl font-black uppercase tracking-tight text-stone-950 sm:text-6xl lg:text-7xl">
          The Shop
        </h1>
        <p className="mt-4 max-w-lg text-sm leading-relaxed text-stone-500 sm:text-base">
          Every piece is sourced to order from our manufacturing partners and personally handled by us. Delivery estimates are shown on each
          product — honest times, no surprises.
        </p>
      </div>

      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <div className="flex flex-wrap gap-2 border-b border-stone-200 pb-8">
          {categories.map((c) => (
            <button
              key={c}
              onClick={() => setCategory(c)}
              className={`px-4 py-2 font-mono text-[11px] font-semibold uppercase tracking-[0.2em] transition-colors ${
                category === c
                  ? "bg-[#E52E39] text-white"
                  : "border border-stone-300 text-stone-700 hover:border-[#E52E39] hover:text-stone-950"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="grid grid-cols-1 gap-4 py-12 sm:grid-cols-2 lg:grid-cols-3">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="aspect-[4/5] animate-pulse bg-[#F1EEE6]" />
            ))}
          </div>
        ) : visible.length === 0 ? (
          <p className="py-24 text-center font-mono text-sm uppercase tracking-widest text-stone-400">
            Nothing here yet — new pieces are dropping soon.
          </p>
        ) : (
          <div className="grid grid-cols-1 gap-4 py-12 sm:grid-cols-2 lg:grid-cols-3">
            {visible.map((p, i) => (
              <Reveal key={p.id} delay={(i % 3) * 0.07}>
                <ProductCard product={p} className="h-full" />
              </Reveal>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
